module.exports = __webpack_public_path__ + "img/10.4c8301e6.png";